export const ADD_AGENT_LOCAL = 'ADD_AGENT_LOCAL';

export function agentAddLocalRequest(data) {
    return {
        type:ADD_AGENT_LOCAL,
        payload: {data},
    };
}
export const AGENT_TIMER_REQUEST = 'AGENT_TIMER_REQUEST';
export const AGENT_TIMER_SUCCESS = 'AGENT_TIMER_SUCCESS';
export const AGENT_TIMER_FAIL = 'AGENT_TIMER_FAIL';

export function agentTimer() {
    return {
        type:AGENT_TIMER_REQUEST,
        payload: {},
    };
}